import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { CheckToken } from "../login/AccessToken";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import SideNavbar from "./SideNavbar";

import "./BillingPayment.scss";
import { Card } from "@mui/material";
import { useLocation } from "react-router-dom/cjs/react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { toast } from "react-toastify";
import AddIcon from "@mui/icons-material/Add";
import { Radio, RadioGroup } from "@mui/material";
import InvoicePayment from "./InvoicePayment";
import ServiceAdditionOnTheGo from "./ServiceAdditionOnTheGo";

import Autocomplete from "@mui/material/Autocomplete";
import { Controller } from "react-hook-form";
import { useForm } from "react-hook-form";

// import Icon from "../doctor-console/Utils/Icons";
import { ReactComponent as CalendarIcon } from "./DummyIcons/calendar-silhouette 2.svg";
import { normalizeBase64Image } from "../utils/utils";
import { displayPatientName } from "../../utils/displayPatientName";

import {
  Grid,
  Button,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Typography,
  Avatar,
  CardContent,
  CircularProgress,
  TextField,
} from "@mui/material";
import { Checkbox, FormControlLabel } from "@mui/material";
import { StyledTextFieldBootstrap } from "../doctor-console/StyledComponents";
import { usePermissions } from "../login/PermissionContext";

const InvoiceAddition = () => {
  const today = new Date().toISOString().split("T")[0];
  const [itemsList, setItemsList] = useState([
    {
      items: "",
      quantity: "",
      price: "",
      discount: "",
      amount: "",
      category: "services",
    },
  ]);
  const [subtotal, setSubtotal] = useState(0);
  const [tax, setTax] = useState(0);
  const [referredBy, setReferredBy] = useState("");
  const [notes, setNotes] = useState("");
  const [invoiceList, setInvoiceList] = useState([]);
  const [nextInvoiceNumber, setNextInvoiceNumber] = useState("");
  const REACT_APP_BACKEND_ROUTE_URL = process.env.REACT_APP_BACKEND_ROUTE_URL;
  const [patientList, setPatientList] = useState([]);
  const [services, setServices] = useState([]);
  const [patientId, setPatientId] = useState("");
  const [fillExpiryDate, setFillExpiryDate] = useState(false);
  const [invoiceDate, setInvoiceDate] = useState(today);
  const [selectedCategory, setSelectedCategory] = useState("services");
  const [servicesList, setServicesList] = useState([]);
  const [isServicesLoading, setIsServicesLoading] = useState(true);
  const [productsList, setProductsList] = useState([]);
  const [dueDate, setDueDate] = useState("");
  const [openPaymentModal, setOpenPaymentModal] = useState(false);
  const [invoiceForPayment, setInvoiceForPayment] = useState(null);
  const [serviceMaster, setServiceMaster] = useState([]);
  const [patientMaster, setPatientMaster] = useState([]);
  const { userInfo } = usePermissions();
  const [openCreateServiceModal, setOpenCreateServiceModal] = useState(false);
  const [activeRowIndex, setActiveRowIndex] = useState(null);
  const servicesFetchedForTokenRef = useRef(null);
  const appliedSnomedSelectionRef = useRef(false);
  const [serviceSearchInputByRow, setServiceSearchInputByRow] = useState({}); // index -> search string for services Autocomplete
  const searchDebounceRef = useRef(null);
  const selectedServicesCacheRef = useRef(new Map()); // id -> option, so selected services stay visible when not in search results

  const searchMedicalServices = (query, ids = null) => {
    if (!authToken) return;
    setIsServicesLoading(true);

    const isGetById = Array.isArray(ids) && ids.length > 0;

    if (isGetById) {
      // Use POST for fetching specific medical service IDs
      axios
        .post(
          `${REACT_APP_BACKEND_ROUTE_URL}get_medical_services/`,
          { medical_service_ids: ids },
          { headers },
        )
        .then((res) => {
          const list =
            res.data?.data ?? res.data?.service_list ?? [];
          const filteredServices = list.filter(
            (service) => !service.expired && service.active,
          );
          setServicesList(filteredServices);
          setServiceMaster(filteredServices);
        })
        .catch((err) =>
          console.error("Error fetching medical services by ID:", err),
        )
        .finally(() => setIsServicesLoading(false));
    } else {
      // Use GET for all services, or POST for search with a query
      if (query && query.trim() !== "") {
        axios
          .post(
            `${REACT_APP_BACKEND_ROUTE_URL}get_medical_services/`,
            { query: query },
            { headers },
          )
          .then((res) => {
            const list =
              res.data?.data ?? res.data?.service_list ?? [];
            const filteredServices = list.filter(
              (service) => !service.expired && service.active,
            );
            setServicesList(filteredServices);
            setServiceMaster(filteredServices);
          })
          .catch((err) =>
            console.error("Error searching medical services:", err),
          )
          .finally(() => setIsServicesLoading(false));
      } else {
        // If user hasn't typed anything, don't fetch full medical services list.
        // This prevents huge dropdown from showing on initial focus.
        setServicesList([]);
        setServiceMaster([]);
        setIsServicesLoading(false);
      }
    }
  };

  const fetchServicesList = () => {
    if (!authToken) return;
    if (medical_service_ids && medical_service_ids.length > 0) {
      searchMedicalServices("", medical_service_ids);
    } else {
      // No IDs and no query => keep empty until user types
      setServicesList([]);
      setServiceMaster([]);
      setIsServicesLoading(false);
    }
  };

  const DEBOUNCE_MS = 1500;
  const handleServiceSearchInputChange = (rowIndex, value) => {
    setServiceSearchInputByRow((prev) => ({ ...prev, [rowIndex]: value }));
    if (searchDebounceRef.current) clearTimeout(searchDebounceRef.current);
    searchDebounceRef.current = setTimeout(() => {
      searchMedicalServices(value);
      searchDebounceRef.current = null;
    }, DEBOUNCE_MS);
  };

  const handleServiceCreated = (service) => {
    if (!service) return;

    fetchServicesList();

    if (activeRowIndex === null || activeRowIndex === undefined) return;

    const updated = [...itemsList];
    if (!updated[activeRowIndex]) return;

    updated[activeRowIndex].items = service.medical_service_id;
    updated[activeRowIndex].price = Number(service.fee || 0).toFixed(2);
    updated[activeRowIndex].amount = calculateLineItemAmount(
      updated[activeRowIndex].quantity || 1,
      Number(service.fee || 0),
      updated[activeRowIndex].discount,
    );

    // Ensure newly created service is selectable even if we haven't fetched all services yet.
    selectedServicesCacheRef.current.set(service.medical_service_id, service);

    setItemsList(updated);
  };

  // Advanced patient search (same search types as Appointment Management)
  const [openPatientSearch, setOpenPatientSearch] = useState(false);
  const [patientSearchType, setPatientSearchType] = useState("abhaId");
  const [patientSearchQuery, setPatientSearchQuery] = useState("");
  const [patientSearchName, setPatientSearchName] = useState("");
  const [patientSearchGender, setPatientSearchGender] = useState("");
  const [patientSearchDob, setPatientSearchDob] = useState("");
  const [patientSearchResults, setPatientSearchResults] = useState([]);
  const [isPatientSearching, setIsPatientSearching] = useState(false);
  const [selectedPatientSearchId, setSelectedPatientSearchId] = useState("");

  // Care contexts (Visit Purpose) – fetched when patient is selected
  const [careContextList, setCareContextList] = useState([]);
  const [selectedCareContext, setSelectedCareContext] = useState("");
  const [isCareContextsLoading, setIsCareContextsLoading] = useState(false);
  const [showCareContextDropdown, setShowCareContextDropdown] = useState(true);
  const isAbdmEnabled =
    sessionStorage.getItem("isAbdmEnabled") !== undefined &&
    sessionStorage.getItem("isAbdmEnabled") !== null
      ? sessionStorage.getItem("isAbdmEnabled")
      : "false";

  const formatAbhaNumber = (abhaNumber) => {
    const digits = String(abhaNumber || "").replace(/\D/g, "");
    if (digits.length !== 14) return abhaNumber || "";
    return digits.replace(/(\d{2})(\d{4})(\d{4})(\d{4})/, "$1-$2-$3-$4");
  };

  const runPatientSearch = async () => {
    if (!authToken) return;

    let filterCriteria;

    if (patientSearchType === "demographics") {
      if (
        !String(patientSearchName || "").trim() &&
        !String(patientSearchGender || "").trim() &&
        !String(patientSearchDob || "").trim()
      ) {
        toast.error("Please enter at least one demographic field.");
        return;
      }
      filterCriteria = {
        filter_type: "demographics",
        filter_details: {
          name: patientSearchName || "",
          gender: patientSearchGender || "",
          dob: patientSearchDob || "",
        },
        multipleResults: true,
      };
    } else {
      const q = String(patientSearchQuery || "").trim();
      if (!q) {
        toast.error("Please enter a search query.");
        return;
      }

      if (patientSearchType === "abhaId") {
        filterCriteria = {
          filter_type: "abha_id",
          filter_details: { abha_id: q },
          multipleResults: true,
        };
      } else if (patientSearchType === "abhaNo") {
        filterCriteria = {
          filter_type: "abha_number",
          filter_details: { abha_number: formatAbhaNumber(q) },
          multipleResults: true,
        };
      } else if (patientSearchType === "phoneNo") {
        filterCriteria = {
          filter_type: "phone_number",
          filter_details: { phone_number: q },
          multipleResults: true,
        };
      } else if (patientSearchType === "patientId") {
        filterCriteria = {
          filter_type: "patient_id",
          filter_details: { patient_id: q },
          multipleResults: true,
        };
      } else {
        toast.error("Invalid search type.");
        return;
      }
    }

    try {
      setIsPatientSearching(true);
      const res = await axios.post(
        `${REACT_APP_BACKEND_ROUTE_URL}get_filtered_patient_data/`,
        filterCriteria,
        { headers },
      );

      if (res?.data?.status === "Success") {
        const found = Array.isArray(res?.data?.patient_details)
          ? res.data.patient_details
          : [];
        setPatientSearchResults(found);
        setSelectedPatientSearchId("");
        toast.success("Patient Found Successfully");
      } else {
        setPatientSearchResults([]);
        setSelectedPatientSearchId("");
        toast.error(res?.data?.message || "No patient found");
      }
    } catch (e) {
      console.error("Patient search failed:", e);
      setPatientSearchResults([]);
      setSelectedPatientSearchId("");
      toast.error("Patient search failed");
    } finally {
      setIsPatientSearching(false);
    }
  };

  const selectPatientFromSearch = (patient) => {
    const id = patient?.patient_id;
    if (!id) return;

    // Ensure the selected patient is available to the existing Autocomplete + invoice flow
    setPatientList((prev) => {
      const list = Array.isArray(prev) ? prev : [];
      const map = new Map(list.map((p) => [p.patient_id, p]));
      map.set(id, { ...(map.get(id) || {}), ...(patient || {}) });
      return Array.from(map.values());
    });
    setPatientMaster((prev) => {
      const list = Array.isArray(prev) ? prev : [];
      const map = new Map(list.map((p) => [p.patient_id, p]));
      map.set(id, { ...(map.get(id) || {}), ...(patient || {}) });
      return Array.from(map.values());
    });

    setValue("patient_id", id);
    setPatientId(id);
    setOpenPatientSearch(false);
  };

  const { control, setValue } = useForm();

  // keep react-hook-form value in sync with selected patient
  useEffect(() => {
    setValue("patient_id", patientId || "");
  }, [patientId, setValue]);

  const handleInvoiceDateChange = (event) => {
    const value = event.target.value;
    setInvoiceDate(value);

    if (fillExpiryDate) {
      setDueDate(value);
    }
  };
  const [authToken, setAuthToken] = useState(
    sessionStorage.getItem("accessToken") !== undefined &&
      sessionStorage.getItem("accessToken") !== null
      ? sessionStorage.getItem("accessToken")
      : "",
  );
  const history = useHistory();
  const headers = {
    Authorization: `Bearer ${authToken}`,
  };

  const fetchCareContextsByFilter = () => {
    if (!authToken || !patientId) {
      setCareContextList([]);
      setSelectedCareContext("");
      return;
    }
    const selectedPatient = patientList.find((p) => p.patient_id === patientId);
    if (!selectedPatient) {
      setCareContextList([]);
      setSelectedCareContext("");
      return;
    }
    setIsCareContextsLoading(true);
    setSelectedCareContext("");
    const postData = {};
    if (isAbdmEnabled === "true" && selectedPatient.abha_id) {
      postData.filter_type = "patient_abha";
      postData.filter_details = { patient_abha: selectedPatient.abha_id };
    } else {
      postData.filter_type = "patient_id";
      postData.filter_details = { patient_id: selectedPatient.patient_id };
    }
    axios
      .post(
        `${REACT_APP_BACKEND_ROUTE_URL}fetch_care_contexts_by_filter/`,
        postData,
        { headers },
      )
      .then((res) => {
        if (res.data.status !== "Failed") {
          const list = res.data.care_contenxts || res.data.care_contexts || [];
          const arr = Array.isArray(list) ? list : [];
          setCareContextList(arr);
          if (arr.length > 0) {
            const first = arr[0];
            setSelectedCareContext(
              first.care_context_reference || first.care_context_id || "",
            );
          }
        } else {
          setCareContextList([]);
          setSelectedCareContext("");
        }
      })
      .catch(() => {
        setCareContextList([]);
        setSelectedCareContext("");
      })
      .finally(() => setIsCareContextsLoading(false));
  };

  useEffect(() => {
    if (!patientId) {
      setCareContextList([]);
      setSelectedCareContext("");
      return;
    }
    fetchCareContextsByFilter();
  }, [patientId]);

  useEffect(() => {
    fetchInvoiceList();
  }, []);
  useEffect(() => {
    if (
      sessionStorage.getItem("accessToken") == undefined &&
      sessionStorage.getItem("accessToken") == null
    ) {
      history.push("/login");
    }
  }, []);

  const isValidDate = (value) => {
    if (!value) return false;

    const date = new Date(value);
    if (isNaN(date.getTime())) return false;

    const [y, m, d] = value.split("-").map(Number);
    return (
      date.getFullYear() === y &&
      date.getMonth() + 1 === m &&
      date.getDate() === d
    );
  };

  const handleInvoiceDateBlur = () => {
    if (!invoiceDate) return;

    if (!isValidDate(invoiceDate)) {
      toast.error("Invalid invoice date");
      setInvoiceDate("");
      return;
    }

    if (invoiceDate < today) {
      toast.error("Invoice date cannot be in the past");
      setInvoiceDate("");
    }
  };

  const handleDueDateChange = (e) => {
    setDueDate(e.target.value);
  };
  const handleDueDateBlur = () => {
    if (!dueDate) return;

    if (!isValidDate(dueDate)) {
      toast.error("Invalid due date");
      setDueDate("");
      return;
    }

    if (invoiceDate && dueDate < invoiceDate) {
      toast.error("Due date must be after invoice date");
      setDueDate("");
    }
  };

  const buildFacilityAddress = (userInfo) => {
    const parts = [
      userInfo?.facility_address_line_1,
      userInfo?.facility_address_line_2,
      userInfo?.facility_address_line_3,
      userInfo?.city,
      userInfo?.state,
      userInfo?.pincode ? `PIN: ${userInfo.pincode}` : null,
    ];

    return parts.filter((x) => x && String(x).trim() !== "").join(", ");
  };

  const [facilityName, setFacilityName] = useState(
    sessionStorage.getItem("facility_name") || "",
  );
  const location = useLocation();
  const {
    selectedDoctors,
    selectedServiceRequests,
    aabhaId,
    medical_service_ids,
    source,
    preselectedInvoicePatient,
  } = location.state || {};
  const preselectedPatientIdFromState =
    preselectedInvoicePatient?.patient_id ||
    preselectedInvoicePatient?.pat_id ||
    "";
  const appliedPreselectedPatientRef = useRef(false);

  console.log(
    "test..",
    selectedDoctors,
    selectedServiceRequests,
    aabhaId,
    medical_service_ids,
    source,
  );

  // useEffect(() => {
  //   const maxInvoice = getMaxInvoiceNumber(invoiceList);
  //   // nextInvoiceNumber(maxInvoice);
  // }, [invoiceList]);

  // useEffect(() => {
  //   const maxInvoice = getMaxInvoiceNumber(invoiceList);
  //   setNextInvoiceNumber(maxInvoice);
  // }, [invoiceList]);

  // const getMaxInvoiceNumber = (invoiceList) => {
  //   if (invoiceList.length === 0) {
  //     return null;
  //   }

  //   const maxInvoiceNumber = invoiceList.reduce((max, invoice) => {
  //     const currentNumber = parseInt(invoice.invoice_number.slice(3), 10);
  //     return currentNumber > max ? currentNumber : max;
  //   }, 0);

  //   const nextInvoiceNumber = maxInvoiceNumber + 1;
  //   console.log("he", nextInvoiceNumber)
  //   return `INV${String(nextInvoiceNumber).padStart(4, '0')}`;
  // };

  // const getMaxInvoiceNumber = (invoiceList) => {
  //   if (invoiceList.length === 0) {
  //     return "INV0001"; // Default invoice number when there are no invoices
  //   }

  //   const maxInvoiceNumber = invoiceList.reduce((max, invoice) => {
  //     const currentNumber = parseInt(invoice.invoice_number.slice(3), 10);
  //     return currentNumber > max ? currentNumber : max;
  //   }, 0);

  //   const nextInvoiceNumber = maxInvoiceNumber + 1;

  //   return `INV${String(nextInvoiceNumber).padStart(4, '0')}`;
  // };

  useEffect(() => {
    if (authToken === "") {
      setIsServicesLoading(false);
      return;
    }

    // Build a key that includes both authToken and medical_service_ids
    const idsKey = medical_service_ids ? medical_service_ids.join(",") : "";
    const fetchKey = `${authToken}_${idsKey}`;

    // Prevent duplicate API call for the same token+IDs
    if (servicesFetchedForTokenRef.current === fetchKey) return;
    servicesFetchedForTokenRef.current = fetchKey;

    // Fetch services - use specific IDs if available, otherwise fetch all
    if (medical_service_ids && medical_service_ids.length > 0) {
      searchMedicalServices("", medical_service_ids);
    } else {
      // No IDs => keep dropdown empty until user types
      setServicesList([]);
      setServiceMaster([]);
      setIsServicesLoading(false);
    }

    // Fetch products
    axios
      .get(`${REACT_APP_BACKEND_ROUTE_URL}get_all_medical_products/`, {
        headers,
      })
      .then((res) => {
        const filteredProducts = res.data.product_list.filter(
          (product) => !product.expired && product.active,
        );
        setProductsList(filteredProducts);
      });
  }, [authToken, medical_service_ids]);

  const fetchInvoiceList = () => {
    if (!authToken) return;

    (async () => {
      try {
        // Preferred: ask backend for full list in one go.
        const res = await axios.post(
          `${REACT_APP_BACKEND_ROUTE_URL}get_all_invoices/`,
          { hip_id: facilityName, is_pagination_required: false },
          { headers: { Authorization: `Bearer ${authToken}` } },
        );

        const pg = res?.data?.pagination;
        const invoices = Array.isArray(res?.data?.invoices)
          ? res.data.invoices
          : [];

        // If backend still paginates even when flag=false, fall back to paging all.
        const backendIgnoredFlag = Boolean(pg?.has_next);
        if (backendIgnoredFlag) {
          const LIMIT = 100; // backend caps limit to 100
          const MAX_PAGES_SAFETY = 1000;
          let page = 1;
          let allInvoices = [];
          let pagesFetched = 0;

          while (pagesFetched < MAX_PAGES_SAFETY) {
            const r = await axios.post(
              `${REACT_APP_BACKEND_ROUTE_URL}get_all_invoices/`,
              {
                hip_id: facilityName,
                is_pagination_required: true,
                page,
                limit: LIMIT,
              },
              { headers: { Authorization: `Bearer ${authToken}` } },
            );

            const pageInvoices = Array.isArray(r?.data?.invoices)
              ? r.data.invoices
              : [];
            allInvoices = allInvoices.concat(pageInvoices);

            const p = r?.data?.pagination;
            if (!p || !p.has_next) break;

            const next = p.next_page;
            if (typeof next === "number" && next > page) {
              page = next;
            } else {
              page = page + 1;
            }

            pagesFetched += 1;
          }

          const invoicesWithId = allInvoices.map((invoice) => ({
            ...invoice,
            id: invoice.invoice_id,
            total: parseFloat(invoice.total_amount).toFixed(2),
          }));
          setInvoiceList(invoicesWithId);
          return;
        }

        const invoicesWithId = invoices.map((invoice) => ({
          ...invoice,
          id: invoice.invoice_id,
          total: parseFloat(invoice.total_amount).toFixed(2),
        }));
        setInvoiceList(invoicesWithId);
      } catch (error) {
        console.error("Error fetching invoice list:", error);
      }
    })();
  };
  // console.log("firstpalce",invoiceList)
  const Token = () => {
    const check = CheckToken();
    console.log(check);
    setAuthToken(sessionStorage.getItem("accessToken"));
    return check;
  };
  useEffect(() => {
    calculateTotalAmount(); // Recalculate total when subtotal or tax changes
  }, [subtotal, tax]);

  // useEffect(() => {
  //   if (authToken !== '') {
  //     axios
  //       .get(`${REACT_APP_BACKEND_ROUTE_URL}get_patient_list_with_aabha_info/`, {
  //         headers: headers,
  //       })
  //       .then((res) => {
  //         setPatientList(res.data);
  //       });

  //   }
  // }, [authToken]);
  // console.log("testing..", services)
  useEffect(() => {
    if (authToken !== "") {
      axios
        .get(
          `${REACT_APP_BACKEND_ROUTE_URL}get_patient_list_with_aabha_info/`,
          {
            headers: headers,
          },
        )
        .then((res) => {
          const patients = res.data?.data || [];
          let mergedPatients = patients;

          // If we arrived here with a preselected patient (from Invoice list),
          // make sure that patient is present in the autocomplete/list data.
          if (
            preselectedPatientIdFromState &&
            !appliedPreselectedPatientRef.current
          ) {
            const existing = patients.find(
              (p) => p.patient_id === preselectedPatientIdFromState,
            );
            if (!existing && preselectedInvoicePatient) {
              mergedPatients = [
                {
                  ...preselectedInvoicePatient,
                  patient_id: preselectedPatientIdFromState,
                },
                ...patients,
              ];
            }
          }

          setPatientList(mergedPatients);
          setPatientMaster(mergedPatients);

          if (
            preselectedPatientIdFromState &&
            !appliedPreselectedPatientRef.current
          ) {
            appliedPreselectedPatientRef.current = true;
            setPatientId(preselectedPatientIdFromState);
          } else if (aabhaId) {
            const selectedPatient = res.data?.data.find(
              (patient) => patient.abha_id === aabhaId,
            );
            if (selectedPatient) {
              setPatientId(selectedPatient.patient_id);
            }
          }
        });
    }
  }, [authToken, aabhaId, preselectedPatientIdFromState]);
  console.log("patientId", patientId);

  // useEffect(() => {
  //   if (authToken !== '') {
  //     axios
  //       .get(`${REACT_APP_BACKEND_ROUTE_URL}get_all_medical_services/`, {
  //         headers: headers,
  //       })
  //       .then((res) => {
  //         const filteredServices = res.data.service_list.filter(service => !service.expired && service.active);

  //         // Set the filtered services
  //         setServices(filteredServices);

  //         // Filter and add matching services to itemsList
  //         if (selectedServiceRequests && selectedServiceRequests.length > 0) {
  //           const matchingItems = filteredServices.filter(service => snomedCodes.includes(service.snomed_code));
  //           const initialItemsList = matchingItems.map(item => ({
  //             items: item.medical_service_id,
  //             quantity: '',
  //             price: item.fee.toFixed(2),
  //             amount: '',
  //           }));
  //           setItemsList(initialItemsList);
  //         }
  //       });
  //   }
  // }, [authToken, selectedServiceRequests]);
  // Use servicesList from the single API call above; no second fetch
  useEffect(() => {
    if (
      !authToken ||
      servicesList.length === 0 ||
      !selectedServiceRequests?.length
    )
      return;
    if (appliedSnomedSelectionRef.current) return;

    setServices(servicesList);

    const requestedIds = (medical_service_ids || []).map((id) => String(id));
    const byServiceId = new Map(
      servicesList.map((s) => [String(s.medical_service_id), s]),
    );
    const matchingItems =
      requestedIds.length > 0
        ? requestedIds.map((id) => byServiceId.get(id)).filter(Boolean)
        : [];

    if (matchingItems.length > 0) {
      appliedSnomedSelectionRef.current = true;
      const initialItemsList = matchingItems.map((item, idx) => {
        const amount = (item.fee * 1).toFixed(2);

        // Keep selected items visible even if user searches and current
        // servicesList no longer contains the chosen value.
        selectedServicesCacheRef.current.set(
          item.medical_service_id,
          item,
        );

        // Sync with react-hook-form state so Autocomplete shows the name
        setValue(`items.${idx}.item_id`, item.medical_service_id);
        setValue(`items.${idx}.category`, "services");

        return {
          category: "services",
          items: item.medical_service_id,
          quantity: "1",
          price: item.fee.toFixed(2),
          discount: "",
          amount: amount,
        };
      });
      setItemsList(initialItemsList);
    }
  }, [
    authToken,
    selectedServiceRequests,
    servicesList,
    medical_service_ids,
    setValue,
  ]);

  const calculateSubtotal = () => {
    const calculatedSubtotal = itemsList.reduce(
      (total, item) => total + parseFloat(item.amount || 0),
      0,
    );
    setSubtotal(calculatedSubtotal);
  };

  const calculateTotalAmount = () => {
    const itemsTotal = itemsList.reduce(
      (total, item) => total + parseFloat(item.amount || 0),
      0,
    );
    const taxAmount = itemsTotal * (tax / 100);
    const totalAmount = itemsTotal + taxAmount;
    return totalAmount.toFixed(2);
  };

  // useEffect(() => {
  //   if (authToken !== "") {
  //     const url =
  //       selectedCategory === "services"
  //         ? `${REACT_APP_BACKEND_ROUTE_URL}get_all_medical_services/`
  //         : `${REACT_APP_BACKEND_ROUTE_URL}get_all_medical_products/`;

  //     axios
  //       .get(url, { headers: headers })
  //       .then((res) => {
  //         const filteredItems =
  //           selectedCategory === "services"
  //             ? res.data.service_list.filter(
  //                 (item) => item.active && !item.expired
  //               )
  //             : res.data.product_list.filter(
  //                 (item) => item.active && !item.expired
  //               );

  //         setServices(filteredItems);
  //       })
  //       .catch((error) => {
  //         console.error(
  //           `Error fetching ${
  //             selectedCategory === "services" ? "services" : "products"
  //           }:`,
  //           error
  //         );
  //       });
  //   }
  // }, [selectedCategory]);

  const handleAddItem = () => {
    setItemsList([
      ...itemsList,
      {
        items: "",
        quantity: "",
        price: "",
        discount: "",
        amount: "",
        category: "services",
      }, // Default category as "services"
    ]);
  };

  const calculateLineItemAmount = (quantity, price, discountPercent) => {
    const qty = parseFloat(quantity) || 0;
    const unitPrice = parseFloat(price) || 0;
    let discountValue = parseFloat(discountPercent);
    if (isNaN(discountValue)) discountValue = 0;
    if (discountValue < 0) discountValue = 0;
    if (discountValue > 100) discountValue = 100;

    const baseAmount = qty * unitPrice;
    const discountAmount = (baseAmount * discountValue) / 100;
    return (baseAmount - discountAmount).toFixed(2);
  };

  const handleItemChange = (index, field, value) => {
    const updatedItemsList = [...itemsList];
    updatedItemsList[index][field] = value;

    if (field === "category") {
      updatedItemsList[index].category = value;
      updatedItemsList[index].items = ""; // Clear selected item
      updatedItemsList[index].price = "";
      updatedItemsList[index].discount = "";
      updatedItemsList[index].amount = "";
    } else if (field === "items") {
      const selectedItem =
        updatedItemsList[index].category === "services"
          ? (servicesList || []).find(
              (s) => s.medical_service_id === value,
            ) ||
            (serviceMaster || []).find(
              (s) => s.medical_service_id === value,
            ) ||
            selectedServicesCacheRef.current.get(value)
          : (productsList || []).find((p) => p.product_id === value);
      if (selectedItem) {
        const quantityValue =
          updatedItemsList[index].quantity === "" ||
          updatedItemsList[index].quantity == null
            ? "1"
            : updatedItemsList[index].quantity;
        updatedItemsList[index].quantity = quantityValue;
        updatedItemsList[index].price = selectedItem.fee.toFixed(2);
        updatedItemsList[index].amount = calculateLineItemAmount(
          updatedItemsList[index].quantity,
          selectedItem.fee,
          updatedItemsList[index].discount,
        );
      } else {
        updatedItemsList[index].quantity = "";
        updatedItemsList[index].price = "";
        updatedItemsList[index].amount = "";
      }
    } else if (field === "quantity") {
      updatedItemsList[index].amount = calculateLineItemAmount(
        value,
        updatedItemsList[index].price,
        updatedItemsList[index].discount,
      );
    } else if (field === "discount") {
      if (value === "") {
        updatedItemsList[index].discount = "";
        updatedItemsList[index].amount = calculateLineItemAmount(
          updatedItemsList[index].quantity,
          updatedItemsList[index].price,
          0,
        );
        setItemsList(updatedItemsList);
        calculateSubtotal();
        return;
      }
      let numericDiscount = parseFloat(value);
      if (isNaN(numericDiscount)) numericDiscount = 0;
      if (numericDiscount < 0) numericDiscount = 0;
      if (numericDiscount > 100) numericDiscount = 100;
      updatedItemsList[index].discount = String(numericDiscount);
      updatedItemsList[index].amount = calculateLineItemAmount(
        updatedItemsList[index].quantity,
        updatedItemsList[index].price,
        numericDiscount,
      );
    }

    setItemsList(updatedItemsList);
    calculateSubtotal();
  };

  const handleTotalChange = (field, value) => {
    let num = parseFloat(value);
    if (isNaN(num)) num = 0;
    if (field === "tax") {
      if (num > 100) num = 100;
      if (num < 0) num = 0;
    }

    if (field === "subtotal") {
      setSubtotal(num);
    } else if (field === "tax") {
      setTax(num);
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    if (!patientId) {
      toast.error("Please select a patient.");
      return;
    }

    const filteredItems = itemsList.filter(
      (item) =>
        item.items &&
        item.quantity != null &&
        item.quantity != null &&
        item.quantity !== "",
    );

    // Check if any required item or quantity is not selected
    if (filteredItems.length !== itemsList.length) {
      console.log(filteredItems.length);
      console.log(itemsList.length);
      toast.error("Please select an item and enter the quantity for all rows.");
      return;
    }

    //const tot = document.getElementById("totalAmount").value;
    const tot = calculateTotalAmount();
    // Validate total_amount
    if (isNaN(tot) || tot <= 0) {
      toast.error("Total amount must be a valid number greater than 0.");
      return;
    }

    //const invoiceDate = document.getElementById("invoiceDate").value;
    //const dueDate = document.getElementById("dueDate").value;
    // const invoiceNumber = document.getElementById('invoiceNumber').value;
    //const patientId = document.getElementById("patientSelect").value;

    //const total = document.getElementById("totalAmount").value;
    const total = tot;

    // Perform due date validation
    if (dueDate < invoiceDate) {
      toast.error("Due date must be after the invoice date.");
      return;
    }

    const itemsListWithItemNames = itemsList.map((item) => {
      const combinedList = [...servicesList, ...productsList];

      const selectedService = combinedList.find(
        (service) => service.medical_service_id === item.items,
      );
      return {
        ...item,
        itemName: selectedService ? selectedService.name : "",
      };
    });

    // Create the request body for creating an invoice
    const tot_Amount = calculateTotalAmount();
    const tot_AmountNumber = parseFloat(tot_Amount);
    // console.log("partial_payment", partialPaymentNumber);
    console.log("totalAmount", tot_AmountNumber);
    const taxNumber = Number(tax);
    const facilityAddress = buildFacilityAddress(userInfo);

    if (taxNumber > 100) {
      toast.error("Tax cannot be more than 100%");
      return;
    }

    const hasInvalidItemDiscount = itemsList.some((item) => {
      const rawValue = item?.discount;
      if (rawValue === "" || rawValue == null) return false;
      const n = Number(rawValue);
      return !Number.isFinite(n) || n < 0 || n > 100;
    });
    if (hasInvalidItemDiscount) {
      toast.error("Each line item discount must be between 0 and 100.");
      return;
    }

    const requestBody = {
      hip_id: facilityName,
      invoice_date: invoiceDate,
      // invoice_number: invoiceNumber,
      due_date: dueDate,
      patient_id: patientId,
      ...(selectedCareContext && { care_context_id: selectedCareContext }),
      note: notes,
      referred_by: String(referredBy || "").trim(),
      total_amount: tot_Amount,
      tax: taxNumber,
      gst_number: "your_gst_number", // Add your GST number here
      // partial_payment: partialPayment,
      items: itemsList.map((item) => ({
        item_id: item.items,
        quantity: parseInt(item.quantity, 10),
        discount_percentage: Number(item.discount || 0),
      })),
    };
    console.log("requestBody", requestBody);
    const selectedPatient = patientList.find(
      (patient) => patient.patient_id === patientId,
    );
    if (!selectedPatient) {
      console.error(
        "Patient details not found for selected patient_id:",
        patientId,
      );
      return;
    }
    const patientName = selectedPatient.name;

    axios
      .post(
        `${REACT_APP_BACKEND_ROUTE_URL}create_invoice/`,
        JSON.stringify(requestBody),
        {
          headers: headers,
        },
      )
      .then((response) => {
        if (
          response.data.status === "Success" &&
          response.data.message === "New invoice created successfully!"
        ) {
          toast.success(response.data.message);
          console.log("Invoice submitted successfully:", response.data);
          const invoiceData = {
            itemsList: itemsListWithItemNames,
            subtotal,
            tax,
            notes,
            invoiceDate,
            dueDate,
            invoiceNumber: response.data.invoice_number,
            // partialPayment,
            total_amount: total,
            patientName: patientName,
            patient_id: selectedPatient?.patient_id,
            age: selectedPatient?.age,
            gender: selectedPatient?.gender,
            phone_no: selectedPatient?.phone_no,
            address: selectedPatient?.address,
            abha_id: selectedPatient?.abha_id,
            referred_by: String(referredBy || "").trim(),
            ...(selectedCareContext && {
              care_context_id: selectedCareContext,
            }),

            // facility data
            facility_name: userInfo?.facility_name || "",
            facility_address: facilityAddress || "",
            center: userInfo?.facility_name || "N/A",
            center_address: facilityAddress || "",
          };
          console.log("invoiceData", invoiceData);

          setInvoiceForPayment({
            ...invoiceData,
            serviceMaster: serviceMaster,
            patientMaster: patientMaster,
          });
          setOpenPaymentModal(true);
        } else {
          console.error("Invoice submission failed:", response.data.message);
          // Handle other cases if needed
        }
      })
      .catch((error) => {
        console.error("Error submitting invoice:", error);
        // Handle errors (e.g., show error message to the user)
      });
  };
  const handleRemoveItem = (indexToRemove) => {
    const updatedItemsList = itemsList.filter(
      (item, index) => index !== indexToRemove,
    );
    setItemsList(updatedItemsList);
    calculateSubtotal();
  };

  const handleNotesChange = (value) => {
    setNotes(value);
  };
  const handleGoBack = () => {
    history.push("/doctor/invoice");
  };

  const handleCheckboxChange = (event) => {
    const { checked } = event.target;
    setFillExpiryDate(checked);

    if (checked) {
      setDueDate(invoiceDate);
    }
  };

  const itemFilterOptions = (options, { inputValue }) => {
    const search = inputValue.toLowerCase().trim();

    if (!search) return options;

    return options.filter(
      (option) => option.name && option.name.toLowerCase().startsWith(search),
    );
  };

  return (
    <>
      <SideNavbar>
        <div className="estimate-addition-wrapper">
          <form onSubmit={handleSubmit}>
            {/* <Grid container>
              <Grid item xs={12} sm={12} md={6}>
                <div className="back-icon" onClick={handleGoBack}>
                  <ArrowBackIcon />
                </div>
              </Grid>
              <Grid item xs={12} sm={12} md={6}></Grid>
            </Grid> */}

            <Card
              sx={{
                // boxShadow: "0px 10px 20px rgba(0, 0, 0, 0.25)",
                borderRadius: "8px",
                padding: "5px 10px",
                margin: "5px 10px",
              }}
            >
              {/* <Grid container>
                <Grid item xs={12} sm={12} md={6}>
                  <div className="back-icon" onClick={handleGoBack}>
                    <ArrowBackIcon />
                  </div>
                </Grid>
                <Grid item xs={12} sm={12} md={6}></Grid>
              </Grid> */}
              <p
                style={{
                  fontWeight: "bold",
                  fontSize: "32px",
                  color: "#172935",
                  marginBottom: "16px",
                }}
              >
                Add New Invoice
              </p>
              <Grid container spacing={4} style={{ alignItems: "flex-start" }}>
                {/* Patient Field (Left Side) */}
                <Grid item xs={12} sm={6} md={6}>
                  <label htmlFor="patient" className="required-label">
                    Patient{" "}
                  </label>
                  {(() => {
                    const selectedPatient =
                      patientList.find((p) => p.patient_id === patientId) ||
                      null;

                    if (!selectedPatient) {
                      return (
                        <>
                          <Card
                            onClick={() => setOpenPatientSearch(true)}
                            sx={{
                              borderRadius: "10px",
                              border: "1px dashed #125386",
                              boxShadow: "none",
                              cursor: "pointer",
                              "&:hover": { backgroundColor: "action.hover" },
                            }}
                          >
                            <CardContent
                              sx={{
                                display: "flex",
                                gap: 2,
                                alignItems: "center",
                              }}
                            >
                              <Avatar
                                sx={{
                                  bgcolor: "#213360",
                                  width: 56,
                                  height: 56,
                                }}
                              >
                                P
                              </Avatar>
                              <div style={{ minWidth: 0 }}>
                                <Typography sx={{ fontWeight: 700 }}>
                                  No patient selected
                                </Typography>
                                <Typography
                                  variant="body2"
                                  sx={{ color: "#6B7A90" }}
                                >
                                  Search by Patient ID / ABHA / Phone /
                                  Demographics
                                </Typography>
                              </div>
                            </CardContent>
                          </Card>
                          <Button
                            type="button"
                            variant="text"
                            size="small"
                            onClick={(e) => {
                              e.stopPropagation();
                              setOpenPatientSearch(true);
                            }}
                            style={{ textTransform: "none", paddingLeft: 0 }}
                          >
                            Search patient
                          </Button>
                        </>
                      );
                    }

                    const photoSrc = normalizeBase64Image(
                      selectedPatient.photo,
                    );
                    const gender = selectedPatient.gender || "-";
                    const dob = selectedPatient.dob || "-";
                    const age =
                      selectedPatient.age !== undefined &&
                      selectedPatient.age !== null
                        ? `${selectedPatient.age}`
                        : "-";
                    const phone =
                      selectedPatient.phone_no ||
                      selectedPatient.phone_number ||
                      "-";

                    return (
                      <>
                        <Card
                          onClick={() => setOpenPatientSearch(true)}
                          sx={{
                            borderRadius: "10px",
                            border: "1px solid #125386",
                            boxShadow: "none",
                            cursor: "pointer",
                            "&:hover": { backgroundColor: "action.hover" },
                          }}
                        >
                          <CardContent
                            sx={{
                              display: "flex",
                              gap: 2,
                              alignItems: "center",
                            }}
                          >
                            <Avatar
                              src={photoSrc || undefined}
                              alt={displayPatientName(selectedPatient.name, "Patient")}
                              sx={{ width: 56, height: 56, bgcolor: "#213360" }}
                            >
                              {String(selectedPatient?.name || "P")
                                .slice(0, 1)
                                .toUpperCase()}
                            </Avatar>
                            <div style={{ minWidth: 0 }}>
                              <Typography sx={{ fontWeight: 800, textTransform: "uppercase" }}>
                                {displayPatientName(selectedPatient.name, "-")}
                              </Typography>
                              <Typography variant="body2">
                                Patient ID: {selectedPatient.patient_id || "-"}
                              </Typography>
                              <Typography variant="body2">
                                Gender: {gender} &nbsp;|&nbsp; DOB: {dob}{" "}
                                &nbsp;|&nbsp; Age: {age}
                              </Typography>
                              <Typography variant="body2">
                                Phone: {phone}
                              </Typography>
                            </div>
                          </CardContent>
                        </Card>

                        <div
                          style={{ display: "flex", gap: 8 }}
                          onClick={(e) => e.stopPropagation()}
                        >
                          <Button
                            type="button"
                            variant="text"
                            size="small"
                            onClick={() => setOpenPatientSearch(true)}
                            style={{ textTransform: "none", paddingLeft: 0 }}
                          >
                            Change patient
                          </Button>
                          <Button
                            type="button"
                            variant="text"
                            size="small"
                            onClick={() => {
                              setPatientId("");
                              setPatientSearchResults([]);
                              setSelectedPatientSearchId("");
                              setCareContextList([]);
                              setSelectedCareContext("");
                            }}
                            style={{ textTransform: "none" }}
                          >
                            Clear
                          </Button>
                        </div>
                      </>
                    );
                  })()}
                </Grid>

                {/* Right Side (Other Fields) */}
                <Grid item xs={12} sm={6} md={6}>
                  <Grid container spacing={2}>
                    {/* Invoice Date */}
                    <Grid item xs={12} sm={6} md={6}>
                      <div className="input-wrapper">
                        <label htmlFor="invoiceDate" className="required-label">
                          Invoice Date{" "}
                        </label>
                        <div
                          className="date-input-container"
                          style={{
                            position: "relative",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <input
                            type="date"
                            className="form-control"
                            id="invoiceDate"
                            name="invoiceDate"
                            value={invoiceDate}
                            required
                            min={today}
                            max="2050-01-01"
                            onChange={handleInvoiceDateChange}
                            onBlur={handleInvoiceDateBlur}
                            onKeyDown={(event) => {
                              if (
                                event.key === "ArrowUp" ||
                                event.key === "ArrowDown"
                              ) {
                                event.preventDefault();
                              }
                            }}
                            style={{ paddingRight: "2.5rem" }}
                          />
                          <i
                            style={{
                              position: "absolute",
                              right: "0.75rem",
                              top: "50%",
                              transform: "translateY(-50%)",
                              cursor: "pointer",
                            }}
                          >
                            <CalendarIcon
                              onClick={() =>
                                document
                                  .getElementById("invoiceDate")
                                  .showPicker?.()
                              }
                            />
                          </i>
                        </div>
                      </div>
                    </Grid>

                    {/* Expiry Date */}
                    <Grid item container xs={12} sm={6} md={6}>
                      <Grid item xs={12}>
                        <div className="input-wrapper">
                          <label htmlFor="dueDate" className="required-label">
                            Due Date{" "}
                          </label>
                          <div
                            className="date-input-container"
                            style={{
                              position: "relative",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <input
                              required
                              type="date"
                              value={dueDate}
                              className="form-control"
                              id="dueDate"
                              name="dueDate"
                              min={invoiceDate || today}
                              max="2050-01-01"
                              disabled={fillExpiryDate}
                              onChange={handleDueDateChange}
                              onBlur={handleDueDateBlur}
                              onKeyDown={(event) => {
                                if (
                                  event.key === "ArrowUp" ||
                                  event.key === "ArrowDown"
                                ) {
                                  event.preventDefault();
                                }
                              }}
                              style={{ paddingRight: "2.5rem" }}
                            />
                            <i
                              style={{
                                position: "absolute",
                                right: "0.75rem",
                                top: "50%",
                                transform: "translateY(-50%)",
                                cursor: "pointer",
                              }}
                            >
                              <CalendarIcon
                                onClick={() =>
                                  document
                                    .getElementById("dueDate")
                                    .showPicker?.()
                                }
                              />
                            </i>
                          </div>
                        </div>
                      </Grid>

                      <Grid item xs={12}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              id="fillExpiryDate"
                              name="fillExpiryDate"
                              checked={fillExpiryDate}
                              onChange={handleCheckboxChange}
                              disabled={!invoiceDate}
                            />
                          }
                          label="Same as Invoice Date"
                        />
                      </Grid>
                    </Grid>

                    {/* Visit Purpose / Care Context – below Invoice Date & Due Date */}
                    {patientId && (
                      <Grid item xs={12} style={{ marginTop: 8 }}>
                        <div>
                          <Button
                            type="button"
                            variant="text"
                            size="small"
                            onClick={() =>
                              setShowCareContextDropdown((prev) => !prev)
                            }
                            style={{
                              textTransform: "none",
                              paddingLeft: 0,
                              marginBottom: 4,
                            }}
                          >
                            {showCareContextDropdown ? "Hide" : "Show"} Visit
                            Purpose (Care Context)
                          </Button>
                          {showCareContextDropdown && (
                            <div style={{ marginTop: 4 }}>
                              <label
                                className="required-label"
                                style={{ display: "block", marginBottom: 4 }}
                              >
                                Visit Purpose
                              </label>
                              {isCareContextsLoading ? (
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 8,
                                  }}
                                >
                                  <CircularProgress size={20} />
                                  <span>Loading visit purposes…</span>
                                </div>
                              ) : (
                                <StyledTextFieldBootstrap
                                  fullWidth
                                  select
                                  value={selectedCareContext}
                                  onChange={(e) =>
                                    setSelectedCareContext(e.target.value)
                                  }
                                >
                                  <MenuItem value="">
                                    No visit purpose selected
                                  </MenuItem>
                                  {(careContextList || []).map((cc) => {
                                    const ref =
                                      cc.care_context_reference ||
                                      cc.care_context_id ||
                                      "";
                                    const display =
                                      cc.display || cc.visit_details || ref;
                                    return (
                                      <MenuItem key={ref} value={ref}>
                                        {display}
                                        {ref ? ` (${ref})` : ""}
                                      </MenuItem>
                                    );
                                  })}
                                </StyledTextFieldBootstrap>
                              )}
                            </div>
                          )}
                        </div>
                      </Grid>
                    )}
                  </Grid>
                </Grid>
              </Grid>
            </Card>

            <Card
              sx={{
                borderRadius: "8px",
                marginBottom: "25px",
                padding: "15px",
                margin: "5px 10px",
                boxShadow: "0px 2px 4px rgba(0,0,0,0.05)"
              }}
            >
              {itemsList.map((item, index) => (
                <Grid
                  container
                  spacing={2}
                  key={index}
                  sx={{
                    mb: 1,
                    p: 2,
                    borderRadius: "8px",
                    backgroundColor: "#E9F5FE", // Restoring the light blue background requested earlier
                    alignItems: "center"
                  }}
                >
                  {/* Category Selection */}
                  <Grid item xs={12} sm={6} md={2}>
                    <RadioGroup
                      row
                      value={item.category || "services"}
                      onChange={(e) => handleItemChange(index, "category", e.target.value)}
                    >
                      <FormControlLabel value="services" control={<Radio size="small" />} label="Services" />
                    </RadioGroup>
                  </Grid>

                  {/* Item Selection */}
                  <Grid item xs={12} sm={6} md={3}>
                    {(() => {
                      const selectedId = item.items;
                      const selectedOption =
                        (servicesList || []).find(
                          (s) => s.medical_service_id === selectedId,
                        ) ||
                        (serviceMaster || []).find(
                          (s) => s.medical_service_id === selectedId,
                        ) ||
                        selectedServicesCacheRef.current.get(selectedId) ||
                        null;

                      const createNewOption = {
                        name: "+ Create New Service",
                        medical_service_id: "new",
                      };

                      const options = (() => {
                        const base = Array.isArray(servicesList)
                          ? servicesList
                          : [];
                        const shouldPrependSelected =
                          selectedOption &&
                          !base.some(
                            (s) =>
                              s.medical_service_id ===
                              selectedOption.medical_service_id,
                          );
                        return shouldPrependSelected
                          ? [selectedOption, ...base, createNewOption]
                          : [...base, createNewOption];
                      })();

                      return (
                        <Autocomplete
                          size="small"
                          fullWidth
                          options={options}
                          value={selectedOption}
                          loading={isServicesLoading}
                          getOptionLabel={(option) => option?.name || ""}
                          isOptionEqualToValue={(option, value) =>
                            option?.medical_service_id ===
                            value?.medical_service_id
                          }
                          noOptionsText={
                            isServicesLoading ? "Loading..." : "No options"
                          }
                          onChange={(_, newValue) => {
                            if (!newValue) {
                              handleItemChange(index, "items", "");
                              setServiceSearchInputByRow((prev) => ({
                                ...prev,
                                [index]: "",
                              }));
                              return;
                            }

                            if (
                              newValue.medical_service_id === "new" ||
                              newValue.product_id === "new"
                            ) {
                              setActiveRowIndex(index);
                              setOpenCreateServiceModal(true);
                              return;
                            }

                            selectedServicesCacheRef.current.set(
                              newValue.medical_service_id,
                              newValue,
                            );
                            setServiceSearchInputByRow((prev) => ({
                              ...prev,
                              [index]: newValue.name || "",
                            }));
                            handleItemChange(
                              index,
                              "items",
                              newValue.medical_service_id,
                            );
                          }}
                          onInputChange={(event, newInputValue, reason) => {
                            if (reason === "input" || reason === "clear") {
                              handleServiceSearchInputChange(
                                index,
                                newInputValue,
                              );
                            }
                          }}
                          inputValue={
                            serviceSearchInputByRow[index] ??
                            selectedOption?.name ??
                            ""
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder="Select Item"
                              sx={{
                                "& .MuiOutlinedInput-root": {
                                  borderRadius: "8px",
                                  backgroundColor: "#ffffff",
                                  minHeight: "38px",
                                  "& .MuiOutlinedInput-notchedOutline": {
                                    borderColor: "#125386",
                                    borderWidth: "1.5px",
                                  },
                                  "&:hover .MuiOutlinedInput-notchedOutline": {
                                    borderColor: "#125386",
                                  },
                                  "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                    {
                                      borderColor: "#125386",
                                      borderWidth: "1.5px",
                                    },
                                },
                                "& .MuiInputBase-input": {
                                  fontSize: "16px",
                                  color: "#495057",
                                },
                                "& .MuiInputBase-input::placeholder": {
                                  color: "#6c757d",
                                  opacity: 1,
                                },
                                "& .MuiAutocomplete-endAdornment .MuiSvgIcon-root":
                                  {
                                    color: "#6c757d",
                                  },
                              }}
                            />
                          )}
                        />
                      );
                    })()}
                  </Grid>

                  {/* Quantity Field */}
                  <Grid item xs={12} sm={4} md={2}>
                    <input
                      type="number"
                      className="form-control"
                      style={{ borderRadius: "8px", border: "1px solid #ced4da" }}
                      placeholder="Enter quantity"
                      value={item.quantity}
                      onChange={(e) =>
                        handleItemChange(index, "quantity", e.target.value)
                      }
                      min="0"
                      onWheel={(e) => e.target.blur()}
                      onKeyDown={(e) => {
                        if (e.key === "-" || e.key === "+") {
                          e.preventDefault();
                        }
                      }}
                    />
                  </Grid>

                  {/* Price Field */}
                  <Grid item xs={12} sm={4} md={1}>
                    <input
                      type="text"
                      className="form-control"
                      style={{ borderRadius: "8px", border: "1px solid #ced4da", backgroundColor: "#fff" }}
                      value={item.price}
                      readOnly
                      placeholder="Price"
                    />
                  </Grid>

                  {/* Line Item Discount Field */}
                  <Grid item xs={12} sm={4} md={1}>
                    <input
                      type="number"
                      className="form-control"
                      style={{ borderRadius: "8px", border: "1px solid #ced4da" }}
                      placeholder="Discount"
                      value={item.discount || ""}
                      onChange={(e) =>
                        handleItemChange(index, "discount", e.target.value)
                      }
                      min="0"
                      max="100"
                      onWheel={(e) => e.target.blur()}
                      onKeyDown={(e) => {
                        if (
                          e.key === "-" ||
                          e.key === "+" ||
                          e.key === "e" ||
                          e.key === "E"
                        ) {
                          e.preventDefault();
                        }
                      }}
                    />
                  </Grid>

                  {/* Amount Field */}
                  <Grid item xs={12} sm={4} md={2}>
                    <input
                      type="text"
                      className="form-control"
                      style={{ borderRadius: "8px", border: "1px solid #ced4da", backgroundColor: "#fff" }}
                      value={item.amount}
                      readOnly
                      placeholder="Amount"
                    />
                  </Grid>

                  {/* Action Field */}
                  <Grid item xs={12} sm={12} md={1}>
                    <Button
                      variant="contained"
                      sx={{
                        backgroundColor: "#bdbdbd",
                        color: "white",
                        minWidth: "80px",
                        padding: "6px 12px",
                        fontSize: "12px",
                        fontWeight: "bold",
                        "&:hover": { backgroundColor: "#9e9e9e" }
                      }}
                      onClick={() => handleRemoveItem(index)}
                    >
                      REMOVE
                    </Button>
                  </Grid>
                </Grid>
              ))}

              <Grid
                container
                spacing={2}
                alignItems="center"
                justifyContent="center"
                sx={{ mt: 2 }}
              >
                <Grid item xs={12}>
                  <center>
                    <button
                      type="button"
                      className="btn btn__secondary btn__rounded btn__block"
                      onClick={handleAddItem}
                      style={{
                        color: "white",
                        padding: "8px 16px",
                        width: "25%",
                        backgroundColor: "#125386",
                        borderRadius: "10px",
                      }}
                    >
                      + ADD
                    </button>
                  </center>
                </Grid>
              </Grid>
            </Card>

            <Card
              sx={{
                borderRadius: "8px",
                marginBottom: "25px",
                padding: "5px 10px",
                margin: "5px 10px",
              }}
            >
              {/* <div className="contact-panel"> */}
              {/* <div style={{ outline: 'none', border: 'none' }}> */}
              <Grid
                container
                spacing={2}
                alignItems="center"
                justifyContent="center"
                style={{ outline: "none", border: "none", boxShadow: "none" }}
              >
                {/* Notes Section */}
                <Grid item xs={12} sm={6}>
                  <div style={{ maxWidth: "100%", flexGrow: 1 }}>
                    {/* <label htmlFor="notes">Notes</label> */}
                    <textarea
                      id="notes"
                      name="notes"
                      placeholder="Notes"
                      value={notes}
                      onChange={(e) => handleNotesChange(e.target.value)}
                      style={{
                        width: "100%",
                        height: "330px",
                        borderRadius: "2%",
                        // border: '1px solid #ccc',
                        // boxShadow: "0px -3px 4px 0px #00000040 inset",
                        padding: "12px 16px",
                      }}
                      className="responsive-textarea"
                    />
                  </div>
                </Grid>

                {/* Pricing Section */}
                <Grid
                  item
                  xs={12}
                  sm={5}
                  md={5}
                  lg={4}
                  style={{ marginLeft: "auto" }}
                >
                  {/* <div className="card" style={{ background: "cream", padding: "30px", borderRadius: "10px" }}> */}
                  {/* <div className="total-section"> */}
                  <Grid container>
                    <Grid item xs={12}>
                      {/* <div className="form-group">
                        <label htmlFor="partialPayment" style={{ color: "#808285" }}>Payment (Rs) {" "}</label>
                        <input
                          type="number"
                          className="form-control"
                          id="partialPayment"
                          name="partialPayment"
                          min="0"
                          onKeyDown={(e) => {
                            if (e.key === "-" || e.key === "+") {
                              e.preventDefault();
                            }
                          }}
                          style={{ width: "100%" }}
                        />
                      </div> */}
                    </Grid>

                    <Grid item xs={12}>
                      <div className="form-group">
                        <label htmlFor="referredBy" style={{ color: "#808285" }}>
                          Referred By
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="referredBy"
                          name="referredBy"
                          value={referredBy}
                          onChange={(e) => setReferredBy(e.target.value)}
                          placeholder="Enter referred by"
                          style={{ width: "100%" }}
                        />
                      </div>
                    </Grid>

                    <Grid item xs={12}>
                      <div className="form-group">
                        <label htmlFor="tax" style={{ color: "#808285" }}>
                          Add Tax (%){" "}
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          id="tax"
                          name="tax"
                          value={0}
                          readOnly
                          disabled
                          style={{ width: "100%" }}
                        />
                      </div>
                    </Grid>

                    <Grid item xs={12}>
                      <div className="form-group">
                        <label
                          htmlFor="totalAmount"
                          style={{ color: "#808285" }}
                        >
                          TOTAL AMOUNT(Rs)
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="totalAmount"
                          name="totalAmount"
                          value={calculateTotalAmount()}
                          readOnly
                          style={{ width: "100%" }}
                        />
                      </div>
                    </Grid>
                  </Grid>
                  {/* </div> */}
                  {/* </div> */}
                </Grid>
              </Grid>
              <Grid
                container
                spacing={2}
                alignItems="center"
                justifyContent="center"
                style={{ marginTop: "5px", marginBottom: "5px" }}
              >
                <Grid item xs={6}>
                  <center>
                    <button
                      // variant="contained"
                      // size="medium"
                      className="btn btn__secondary btn__rounded btn__block mt-2"
                      type="submit"
                      style={{
                        color: "white",
                        padding: "8px 16px",
                        width: "50%",
                        // transition: "background-color 0.3s ease",
                        backgroundColor: "#0e3f66",
                        borderRadius: "10px",
                        // boxShadow: "0px 4px 4px 0px #00000040 inset"
                      }}
                    >
                      SUBMIT
                    </button>
                  </center>
                </Grid>
                <Grid item xs={6}>
                  <center>
                    <button
                      type="button"
                      onClick={handleGoBack}
                      // variant="contained"
                      // size="medium"
                      className="btn btn__secondary btn__rounded btn__block mt-2"
                      style={{
                        color: "white",
                        padding: "8px 16px",
                        width: "50%",
                        // transition: "background-color 0.3s ease",
                        backgroundColor: "#0e3f66",
                        borderRadius: "10px",
                        // boxShadow: "0px 4px 4px 0px #00000040 inset"
                      }}
                    >
                      CANCEL
                    </button>
                  </center>
                </Grid>
              </Grid>

              {/* </div> */}
              {/* </div> */}
            </Card>
          </form>
          <InvoicePayment
            open={openPaymentModal}
            onClose={() => setOpenPaymentModal(false)}
            invoice={invoiceForPayment}
            onStatusUpdated={() => {}}
            onAfterClose={() => {}}
            disableClose={true}
            onPaymentSuccess={() => {
              // Only update lab test status when coming from Staging Area
              if (
                selectedServiceRequests &&
                selectedServiceRequests.length > 0
              ) {
                const labTestPayload = {
                  lab_tests: selectedServiceRequests.map((labTestId) => ({
                    lab_test_id: labTestId,
                    status: "PAID",
                  })),
                };
                console.log("Updating lab test status:", labTestPayload);
                axios
                  .post(
                    `${REACT_APP_BACKEND_ROUTE_URL}change_patient_lab_test_status/`,
                    JSON.stringify(labTestPayload),
                    { headers: headers },
                  )
                  .then((res) => {
                    console.log("Lab test status updated:", res.data);
                  })
                  .catch((err) => {
                    console.error("Error updating lab test status:", err);
                  });
              }
            }}
          />
          <ServiceAdditionOnTheGo
            open={openCreateServiceModal}
            onClose={() => setOpenCreateServiceModal(false)}
            onCreated={handleServiceCreated}
          />

          <Dialog
            open={openPatientSearch}
            onClose={() => setOpenPatientSearch(false)}
            fullWidth
            maxWidth="md"
          >
            <DialogTitle
              sx={{
                backgroundColor: "#213360",
                color: "#FFFFFF",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <span>Search Patient</span>
              <IconButton onClick={() => setOpenPatientSearch(false)}>
                <span style={{ color: "#FFFFFF", fontSize: 22 }}>×</span>
              </IconButton>
            </DialogTitle>

            <DialogContent dividers>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <label className="required-label">Search By</label>
                  <StyledTextFieldBootstrap
                    fullWidth
                    select
                    value={patientSearchType}
                    onChange={(e) => {
                      setPatientSearchType(e.target.value);
                      setPatientSearchResults([]);
                      setSelectedPatientSearchId("");
                    }}
                  >
                    <MenuItem value="patientId">Patient ID</MenuItem>
                    <MenuItem value="abhaId">ABHA Address</MenuItem>
                    <MenuItem value="abhaNo">ABHA No</MenuItem>
                    <MenuItem value="phoneNo">Phone No</MenuItem>
                    <MenuItem value="demographics">Demographics</MenuItem>
                  </StyledTextFieldBootstrap>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <label>Enter Search Query</label>
                  <StyledTextFieldBootstrap
                    fullWidth
                    placeholder="Enter your search query"
                    value={patientSearchQuery}
                    onChange={(e) => setPatientSearchQuery(e.target.value)}
                    disabled={patientSearchType === "demographics"}
                  />
                </Grid>

                <Grid item xs={12} sm={4}>
                  <label>Name</label>
                  <StyledTextFieldBootstrap
                    fullWidth
                    placeholder="Enter patient name"
                    value={patientSearchName}
                    onChange={(e) => setPatientSearchName(e.target.value)}
                    disabled={patientSearchType !== "demographics"}
                  />
                </Grid>

                <Grid item xs={12} sm={4}>
                  <label>Gender</label>
                  <StyledTextFieldBootstrap
                    fullWidth
                    select
                    value={patientSearchGender}
                    onChange={(e) => setPatientSearchGender(e.target.value)}
                    disabled={patientSearchType !== "demographics"}
                  >
                    <MenuItem value="">Select Gender</MenuItem>
                    <MenuItem value="M">Male</MenuItem>
                    <MenuItem value="F">Female</MenuItem>
                    <MenuItem value="O">Other</MenuItem>
                  </StyledTextFieldBootstrap>
                </Grid>

                <Grid item xs={12} sm={4}>
                  <label>Date of Birth</label>
                  <StyledTextFieldBootstrap
                    fullWidth
                    type="date"
                    value={patientSearchDob}
                    onChange={(e) => setPatientSearchDob(e.target.value)}
                    disabled={patientSearchType !== "demographics"}
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>
              </Grid>

              <div style={{ marginTop: 16 }}>
                <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>
                  Results
                </Typography>

                {isPatientSearching ? (
                  <div
                    style={{ display: "flex", alignItems: "center", gap: 10 }}
                  >
                    <CircularProgress size={20} />
                    <span>Searching…</span>
                  </div>
                ) : patientSearchResults && patientSearchResults.length > 0 ? (
                  <Grid container spacing={2}>
                    {patientSearchResults.map((p) => {
                      const isSelected =
                        selectedPatientSearchId === p.patient_id;
                      const phoneVal = p.phone_no || p.phone_number || "-";
                      return (
                        <Grid item xs={12} sm={6} key={p.patient_id}>
                          <Card
                            onClick={() => {
                              setSelectedPatientSearchId(p.patient_id);
                              selectPatientFromSearch(p);
                            }}
                            sx={{
                              cursor: "pointer",
                              border: isSelected
                                ? "2px solid #21cdc0"
                                : "1px solid #E3EFF0",
                              borderRadius: "10px",
                            }}
                          >
                            <CardContent sx={{ display: "flex", gap: 2 }}>
                              <Avatar
                                src={
                                  normalizeBase64Image(p?.photo) || undefined
                                }
                                alt={p?.name || "Patient"}
                                sx={{ bgcolor: "#213360" }}
                              >
                                {String(p?.name || "P")
                                  .slice(0, 1)
                                  .toUpperCase()}
                              </Avatar>
                              <div style={{ minWidth: 0 }}>
                                <Typography sx={{ fontWeight: 700 }}>
                                  {p?.name || "-"}
                                </Typography>
                                <Typography variant="body2">
                                  Patient ID: {p?.patient_id || "-"}
                                </Typography>
                                <Typography variant="body2">
                                  Phone: {phoneVal}
                                </Typography>
                                <Typography variant="body2">
                                  ABHA Number: {p?.abha_no || "-"}
                                </Typography>
                                <Typography variant="body2">
                                  ABHA Address: {p?.abha_id || "-"}
                                </Typography>
                              </div>
                            </CardContent>
                          </Card>
                        </Grid>
                      );
                    })}
                  </Grid>
                ) : (
                  <Typography variant="body2" sx={{ color: "#6B7A90" }}>
                    No results to show.
                  </Typography>
                )}
              </div>
            </DialogContent>

            <div
              style={{
                padding: "16px 24px",
                display: "flex",
                gap: "10px",
                width: "100%",
              }}
            >
              <button
                type="button"
                className="btn btn__secondary btn__block"
                onClick={() => setOpenPatientSearch(false)}
              >
                CLOSE
              </button>
              <button
                type="button"
                className="btn btn__secondary btn__block"
                onClick={runPatientSearch}
                disabled={isPatientSearching}
              >
                {isPatientSearching ? "SEARCHING..." : "SEARCH"}
              </button>
            </div>
          </Dialog>
        </div>
      </SideNavbar>
    </>
  );
};

export default InvoiceAddition;
